import type { ListTableDivRef } from "../list-table.type";

export const getListTableContentNode = (tableRef: ListTableDivRef) => {
  const wrapper = tableRef.current;
  const node = wrapper?.querySelector(".app-table-content");

  return node ? (node as HTMLElement) : node;
};
